import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=0049ccaa&"
import script from "./AppModal.vue?vue&type=script&lang=js&"
export * from "./AppModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0049ccaa')) {
      api.createRecord('0049ccaa', component.options)
    } else {
      api.reload('0049ccaa', component.options)
    }
    module.hot.accept("./AppModal.vue?vue&type=template&id=0049ccaa&", function () {
      api.rerender('0049ccaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/components/AppModal.vue"
export default component.exports